var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    {
      attrs: { value: "", "escape-close": "" },
      on: {
        input: function ($event) {
          return _vm.close()
        },
      },
    },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [
            _vm._v(_vm._s(_vm.$ct("edit-email-address-settings"))),
          ]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("is-default-mail") },
                        model: {
                          value: _vm.isDefaultValue,
                          callback: function ($$v) {
                            _vm.isDefaultValue = $$v
                          },
                          expression: "isDefaultValue",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("is-default-for-reminders") },
                        model: {
                          value: _vm.isDefaultForReminderValue,
                          callback: function ($$v) {
                            _vm.isDefaultForReminderValue = $$v
                          },
                          expression: "isDefaultForReminderValue",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { label: _vm.$ct("label") },
                        model: {
                          value: _vm.settings.Label,
                          callback: function ($$v) {
                            _vm.$set(_vm.settings, "Label", $$v)
                          },
                          expression: "settings.Label",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-sale-type-multi-select", {
                        attrs: {
                          "use-id": "",
                          label: _vm.$ct("use-email-for-sale-types"),
                          "contact-group-id": _vm.groupId,
                        },
                        model: {
                          value: _vm.settings.UseForSaleTypeIDs,
                          callback: function ($$v) {
                            _vm.$set(_vm.settings, "UseForSaleTypeIDs", $$v)
                          },
                          expression: "settings.UseForSaleTypeIDs",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  staticClass: "confirm",
                  attrs: { icon: "check" },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }